import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideMenuItemSizeDescription',
  initialState: false,
  reducers: {
    setHideMenuItemSizeDescription(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHideMenuItemSizeDescription } = slice.actions;

export default slice.reducer;
